module.exports = __webpack_public_path__ + "static/media/card_0.c6770465.png";